module.exports = __webpack_public_path__ + "img/zh_redpacket.f1ca075a.png";